/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import PropTypes, { bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',

    },
    modalContainer: {
        backgroundColor: theme.palette.white,
        position: 'relative',
        overflow: 'auto',
        minWidth: '280px',
        maxWidth: '440px',
        maxHeight: '795px',
        width: '90%',
        height: '95%',
    },
    headingText: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        textTransform: 'uppercase',
        position: 'sticky',
        top: '1px',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: theme.palette.white,
        fontSize: '16px',
        lineHeight: '48px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: '0 10px',
        padding: '0 4px',
        fontFamily: 'museo-sans, "Area Variable", LatoBold',
        borderBottom: `3px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        textAlign: 'center',
        zIndex: '1',
    },
    alignTextLeft: {
        textAlign: 'left',
    },
    description: {
        background: theme.palette.white,
        overflowY: 'auto',
        padding: '15px 10px 0',
    },
    right: {
        right: '24px',
        position: 'absolute',
        fontSize: '20px',
        fontWeight: '100',
        cursor: 'pointer',
        top: '6px',
        width: '20px',
    },
    itemUi: {
        display: 'flex',
        width: '100%',
    },
    itemContent: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingRight: '15px',
    },
    itemLabelName: {
        [theme.breakpoints.down('600')]: {
            fontSize: '14px',
            paddingRight: '5px',
        },
    },
    addonCheckbox: {
        [theme.breakpoints.down('600')]: {
            marginRight: 0,
            '& svg': {
                fontSize: '24px',
            },
        },
    },
    checkbox: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        padding: '4px 11px',
        '&$checked': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    checked: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        '&$checked': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
    },
    ctaButton: {
        margin: '20px auto',
        display: 'block',
        width: '200px',
        color: theme?.palette?.white,
        textAlign: 'center',
        lineHeight: '20px',
        backgroundColor: theme?.palette?.primaryButton || '#201648',
        borderRadius: '4px',
        cursor: 'pointer',
        fontWeight: '500',
        fontSize: '14px',
        textTransform: 'uppercase',
        '&:hover, &:focus, &:active': {
            backgroundColor: theme?.palette?.primaryButton || '#201648',
        },
        [theme?.breakpoints?.down('md')]: {
            fontSize: '16px',
        },
    },
    label: {
        width: '100%',
        fontSize: '15px',
    },
    rootControlLabel: {
        margin: '3px 10px 3px 0',
        width: '100%',
    },
    price: {
        fontSize: '15px',
    },
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        fontWeight: '400',
    },
    addonLabelName: {},
    modelWrapper: {
        '& $addonLabelName, $price': {
            fontSize: '16px',
            fontWeight: '500',
            lineHeight: '24px',
            display: 'flex',
            flexWrap: 'wrap',
        },
        '& $price': {
            justifyContent: 'flex-end',
        },
        '& $rootControlLabel': {
            margin: '16px 7px 16px 0px ',
            alignItems: 'flex-start',
        },
        '& $checkbox': {
            padding: '0px 12px 0px 0px',
            color: '#9D9D9D',
            '& svg': {
                width: '24px',
                height: '24px',
                fontSize: '24px',
                borderRadius: '3px',
            },
        },
        '& $itemUi': {
            borderBottom: '1px solid #dfdfdf',
        },
        '& $ctaButton': {
            width: '100%',
            padding: '15px 0px',
            margin: '0px',
            fontSize: '18px',
            lineHeight: '26px',
            fontWeight: 700,
            textTransform: 'inherit',
            fontFamily: 'museo-sans, "Area Variable", LatoBold',
        },
        '& $right': {
            cursor: 'pointer',
            position: 'absolute',
            fontSize: '14px',
            lineHeight: 'normal',
            top: '8px',
            padding: '5px',
            right: '5px',
            '& svg': {
                width: '20px',
                height: '20px',
            },
        },
        '& $modalContainer': {
            maxWidth: '414px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        '& $headingText': {
            color: '#000000',
            borderBottom: '1px solid #DFDFDF',
            fontSize: '24px',
            lineHeight: '36px',
            textTransform: 'inherit',
            position: 'sticky',
            top: '0px',
            padding: '33px 0px 13px',
            minHeight: '83px',
            '@media screen and (max-width: 440px)': {
                fontSize: '20px',
            },
        },
        '& $description': {
            padding: '0px 10px 15px',
            marginBottom: 'auto',
        },
    },
    ctaContainer: {
        padding: '10px',
        position: 'sticky',
        boxShadow: '0px -2px 20px 0px #0000002E',
        zIndex: '1',
        bottom: '0',
        background: '#fff',
    },
    salePrice: {
        marginLeft: '3px',
        color: '#a1001a',
    },
});

const ModalItemWrapper = (props) => {
    const {
        modalItemList = [], classes, onCloseModal, isOpen, btnClose,
        alignItem, selectItems, groupItemId, groupItemName, wrapupAddonRedesign,
        selectedItems, typeItem,
    } = props;
    let classTitle = classes.headingText;

    if (alignItem === 'left') {
        classTitle = `${classes.headingText} ${classes.alignTextLeft}`;
    }

    // Only the id of the selected addons
    const selectedItemIds = [];
    if (typeItem === 'addons' && selectedItems && selectedItems.length > 0) {
        selectedItems.forEach((item) => {
            selectedItemIds.push(item.id);
        });
    } else if (typeItem === 'wrapup' && selectedItems && selectedItems.id) {
        selectedItemIds.push(selectedItems.id);
    }

    const handleChange = (event, skuItem) => {
        const valueItem = event.target.value;
        if (typeItem === 'addons') {
            if (valueItem) {
                const addon = modalItemList
                    .map((item) => item)
                    .filter((item) => item.id === valueItem);
                if (addon.length > 0) {
                    selectItems(addon[0], groupItemId, groupItemName);
                }
            } else {
                selectItems('', groupItemId, groupItemName);
            }
        } else if (typeItem === 'wrapup') {
            selectItems(skuItem);
        }
    };

    const getWrapUpUI = () => {
        const wrapup = modalItemList;
        const priceSku = wrapup.sku.prices || [];

        // Gets the value of sale price from the sku.
        const retailPrice = priceSku.find((price) => price.type === 'retail')?.value || null;
        const salePrice = priceSku.find((price) => price.type === 'sale')?.value || null;
        const defaultPrice = `$${priceSku?.[0]?.value}`;
        return (
            <div className={classes.itemUi}>
                <FormControlLabel
                    value={wrapup?.sku?.id}
                    className={classes.rootControlLabel}
                    classes={{
                        label: classes.label,
                    }}
                    control={(
                        <Checkbox
                            id={`checkbox-${wrapup.sku.id}`}
                            data-testid={`checkbox-${wrapup.sku.id}`}
                            checked={selectedItemIds.includes(wrapup.sku.id)}
                            classes={{
                                root: classes.checkbox,
                                checked: classes.checked,
                            }}
                            onChange={(e) => handleChange(e, wrapup.sku)}
                        />
                    )}
                    label={(
                        <Grid container className={classes.checkboxWrapper}>
                            <Grid item xs={9} md={9} lg={9} align="left" className={classes.addonLabelName}>
                                {wrapup?.sku?.name}
                            </Grid>
                            <Grid item xs={3} md={3} lg={3} align="right" className={classes.price}>
                                {
                                    salePrice && retailPrice && salePrice !== retailPrice
                                        ? (
                                            <>
                                                <s>
                                                    (${retailPrice})
                                                </s>
                                                <span className={classes.salePrice}>
                                                    ${salePrice}
                                                </span>

                                            </>
                                        )
                                        : <span className={classes.defaultPrice}>{defaultPrice}</span>
                                }
                            </Grid>
                        </Grid>
                    )}
                />
            </div>
        );
    };
    const renderCta = () => (
        <Button
            id="modalBtnContinue"
            data-testid="modalBtnContinue"
            variant="contained"
            className={classes.ctaButton}
            onClick={() => onCloseModal()}
        >
            Continue
        </Button>
    );
    return (
        <Modal id="modalItemWrapper" open={isOpen} className={`${classes.modal} ${wrapupAddonRedesign ? classes.modelWrapper : ''}`}>
            <div className={classes.modalContainer}>
                <div className={classTitle}>
                    Please make your selections
                    {
                        btnClose
                        && (
                            <span
                                id="btnClose"
                                data-testid="modalBtnClose"
                                className={classes.right}
                                onClick={() => onCloseModal()}
                                onKeyDown={() => { }}
                                role="button"
                                tabIndex={-1}
                            >   <CloseIcon className={classes.closeIcon} />
                            </span>
                        )
                    }
                </div>
                <div className={classes.description}>
                    {typeItem === 'addons' && modalItemList.length > 0 && modalItemList.map((addon) => {
                        const retailPrice = addon?.prices?.[0].type === 'retail' ? addon?.prices?.[0].value : null;
                        const salePrice = addon?.prices?.[1].type === 'sale' ? addon?.prices?.[1].value : null;
                        return (
                            <Grid container key={addon?.id} className={classes.checkboxWrapper}>
                                <div className={classes.itemUi}>
                                    <FormControlLabel
                                        value={addon?.id}
                                        className={classes.rootControlLabel}
                                        classes={{
                                            label: classes.label,
                                        }}
                                        control={(
                                            <Checkbox
                                                id={`checkbox-${addon?.id}`}
                                                data-testid={`checkbox-${addon?.id}`}
                                                checked={selectedItemIds.includes(addon?.id)}
                                                classes={{
                                                    root: classes.checkbox,
                                                    checked: classes.checked,
                                                }}
                                                onChange={(e) => handleChange(e)}
                                            />
                                        )}
                                        label={(
                                            <Grid container className={classes.checkboxWrapper}>
                                                <Grid item xs={8} md={8} lg={8} align="left" className={classes.addonLabelName}>
                                                    {addon?.name}
                                                </Grid>
                                                <Grid item xs={4} md={4} lg={4} align="right" className={classes.price}>
                                                    {
                                                        salePrice && retailPrice && salePrice !== retailPrice && addon?.brandId === '1034'
                                                            ? (
                                                                <>
                                                                    <span className={classes.crossedOutRetailPrice}>
                                                                        ${retailPrice}
                                                                    </span>
                                                                    <span className={classes.salePrice}>
                                                                        <b>${salePrice}</b>
                                                                    </span>
                                                                </>
                                                            )
                                                            : <>${addon?.prices?.[0]?.value || addon?.prices?.[1]?.value}</>
                                                    }
                                                </Grid>
                                            </Grid>
                                        )}
                                    />
                                </div>
                            </Grid>
                        );
                    })}
                    {typeItem === 'wrapup' && modalItemList && modalItemList.sku && getWrapUpUI()}

                    {!wrapupAddonRedesign && renderCta()}
                </div>
                {wrapupAddonRedesign
                && (
                    <div className={classes.ctaContainer}>
                        {renderCta()}
                    </div>
                )}
            </div>
        </Modal>
    );
};

ModalItemWrapper.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    modalItemList: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.string,
            image: PropTypes.object,
            name: PropTypes.string,
            partNumber: PropTypes.string,
            prices: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.number,
            })),
        }),
        PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            image: PropTypes.object,
            name: PropTypes.string,
            partNumber: PropTypes.string,
            prices: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.number,
            })),
        })),
    ]).isRequired,
    selectedItems: PropTypes.oneOfType([
        PropTypes.shape({
            id: PropTypes.string,
            image: PropTypes.object,
            name: PropTypes.string,
            partNumber: PropTypes.string,
            prices: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.number,
            })),
        }),
        PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            image: PropTypes.object,
            name: PropTypes.string,
            partNumber: PropTypes.string,
            prices: PropTypes.arrayOf(PropTypes.shape({
                type: PropTypes.string,
                value: PropTypes.number,
            })),
        })),
    ]).isRequired,
    onCloseModal: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    btnClose: PropTypes.bool,
    alignItem: PropTypes.string,
    selectItems: PropTypes.func.isRequired,
    groupItemId: PropTypes.string.isRequired,
    groupItemName: PropTypes.string.isRequired,
    typeItem: PropTypes.string.isRequired,
    wrapupAddonRedesign: bool,
};

ModalItemWrapper.defaultProps = {
    btnClose: true,
    alignItem: 'center',
    wrapupAddonRedesign: false,
};

export default withStyles(styles)(ModalItemWrapper);
